/**
 * To support all of the legacy links to single group pages, we redirect to the new one
 */

import React from "react";

import { Redirect, useParams } from "react-router-dom";
import { useGetMyGroupUsers } from "../../groupUser/groupUserService";

const LegacySingleGroupRedirect = () => {
  const { groupId } = useParams();
  const urlParams = new URLSearchParams(window.location.search);
  // fetch group to get organizationId
  const { data: groupUser, isLoading, isError } = useGetMyGroupUsers({ _group: groupId });

  if (isLoading) {
    return <div>Redirecting...</div>;
  }
  if (isError) {
    // this means invalid groupId or user has no access
    return <Redirect to="/" />;
  }

  if (groupUser && groupUser.length > 0) {
    const organizationId = groupUser[0]._organization;
    return <Redirect to={`/${organizationId}/${groupId}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`} />;
  } else {
    // if we can't find the group user, redirect to home
    return <Redirect to="/" />;
  }
}

export default LegacySingleGroupRedirect;